const __WEBPACK_NAMESPACE_OBJECT__ = coreApis.componentApis.live.liveControlBar;